import React from 'react';
import cn from 'classnames';

import {useSetUI} from 'coreHooks';

import Button from 'brandComponents/Button';

import {ISizeSelectorButtonProps} from './ISizeSelectorButtonProps';

const SizeSelectorButton = ({
	variationGroupId,
	variantId,
	label,
	handleClick,
	variant,
	classNames,
	countryCode,
	hidePreorderSizes = false
}: ISizeSelectorButtonProps) => {
	const setUI = useSetUI();

	const _handleClick = () => {
		setUI.showSizeSelector(variationGroupId, variantId, null, null, countryCode, hidePreorderSizes);

		handleClick?.();
	};

	return (
		<Button
			classNames={cn(classNames, 'product_size_selector')}
			onClick={_handleClick}
			variant={variant}
			dataIds={variantId ? {'data-variation-id': variantId} : {}}
		>
			{label}
		</Button>
	);
};

export default SizeSelectorButton;
